import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Hazard = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.23825 6.85368C7.22563 6.44432 7.55404 6.10562 7.9636 6.10562H8.03614C8.44638 6.10562 8.77506 6.4454 8.76144 6.85541L8.6866 9.10816C8.67425 9.47999 8.36924 9.77504 7.9972 9.77504C7.62452 9.77504 7.31923 9.47902 7.30774 9.10652L7.23825 6.85368Z"
        fill="currentColor"
      />
      <path
        d="M8.0001 11.6435C8.34561 11.6435 8.6257 11.3634 8.6257 11.0179C8.6257 10.6724 8.34561 10.3923 8.0001 10.3923C7.65459 10.3923 7.37451 10.6724 7.37451 11.0179C7.37451 11.3634 7.65459 11.6435 8.0001 11.6435Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9934 2.90729C8.56931 2.11308 7.43085 2.11308 7.00675 2.90728L2.13431 12.0319C1.73376 12.782 2.27728 13.6884 3.12763 13.6884H12.8724C13.7227 13.6884 14.2662 12.782 13.8657 12.0319L8.9934 2.90729ZM3.33628 12.4372L8.00007 3.70333L12.6637 12.4372H3.33628Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Hazard;
